module.exports = __webpack_public_path__ + "assets/71c85a1d3d6ae9f293b0d1424a80dbeb-DSC_0828.jpg";